module.exports = __webpack_public_path__ + "static/media/error.9a2d9cee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/error.svg
// module id = 865
// module chunks = 21